import styles from './ResourcesSection.module.scss';
import { ArrowSquareOut } from '@phosphor-icons/react';
import {
  HELP_CENTER_ACCOUNT_LOGIN_BILLING_LINK,
  HELP_CENTER_GETTING_STARTED_LINK,
} from 'src/constants/externalLinks';
import { SVG_SIZE_M } from 'src/constants';

export const ResourcesSection = () => {
  return (
    <div className={styles.root}>
      <h4 className={styles.title}>Resources</h4>

      <div className={styles.infoBlock}>
        <h5 className={styles.subtitle}>How to get the most out of Ninja</h5>
        <span className={styles.description}>
          Find best practices for using Ninja skills, and discover advanced ways
          to help make you more productive.
        </span>
        <a
          href={HELP_CENTER_GETTING_STARTED_LINK}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          <span>Go to Help Center</span>
          <ArrowSquareOut size={SVG_SIZE_M} />
        </a>
      </div>

      <div className={styles.infoBlock}>
        <h5 className={styles.subtitle}>Billing & account FAQ</h5>
        <span className={styles.description}>
          Get answers to common billing questions, payment methods, and
          subscription plan management.
        </span>
        <a
          href={HELP_CENTER_ACCOUNT_LOGIN_BILLING_LINK}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          <span>Go to Help Center</span>
          <ArrowSquareOut size={SVG_SIZE_M} />
        </a>
      </div>
    </div>
  );
};
